module.exports = __webpack_public_path__ + "static/fun-time/audio/karta2//11_green.mp3";